import { render } from "./CarouselSlideComponent.vue?vue&type=template&id=3af2b994"
import script from "./CarouselSlideComponent.vue?vue&type=script&lang=js"
export * from "./CarouselSlideComponent.vue?vue&type=script&lang=js"

import "./CarouselSlideComponent.vue?vue&type=style&index=0&id=3af2b994&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__